import Basic from '@rebuild/materials/shared/home_wrapper/MenuBlock.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/home_wrapper/context';
import { useCommonData } from '@/hooks';
import IMG_MODULE_BG_ACTIVITY from '@/assets/images/home/module_bg_activity.png';
import IMG_MODULE_BG_QUARTERLY from '@/assets/images/home/module_bg_quarterly.png';
import IMG_MODULE_BG_QUARTERLY_BLUE from '@/assets/images/home/module_bg_quarterly_blue.png';

function useSelfContext() {
	const { getUpperThemeColor } = useCommonData();

	const getQuarterlyPerformanceBg = () => {
		const isBlueTheme = getUpperThemeColor.value == '#3964E5';
		return isBlueTheme ? IMG_MODULE_BG_QUARTERLY_BLUE : IMG_MODULE_BG_QUARTERLY;
	};

	const getModuleBgMap = {
		quarterly_performance: {
			getCover: getQuarterlyPerformanceBg
		},
		investment_activity: {
			getCover: () => IMG_MODULE_BG_ACTIVITY
		}
	};

	provideCurrentContext({
		getModuleBgMap
	});
}

export const componentMap = {
	basic: withProvider(Basic, useSelfContext)
};
